import React from "react";
import Highlight from "react-highlighter";
import styled from "styled-components";

import { Objective } from "@examspark/types";

const OptionText = styled.div`
  line-height: 2rem;
`;

const OptionAbbreviation = styled.span`
  padding: 0.5rem;
  font-size: 0.9rem;
  font-family: input-mono;
  background-color: #f7f7f7;
  border: solid 1px #ddd;
  border-radius: 0.3rem;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
`;

interface Props {
  objective: Objective;
  highlightText?: string;
}

const ObjectiveText: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <OptionText>
      <OptionAbbreviation>{props.objective.abbreviation}</OptionAbbreviation>
      <Highlight search={props.highlightText || ""}>
        {props.objective.content}
      </Highlight>
    </OptionText>
  );
};

export default ObjectiveText;
